import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Brand from '../components/Brand';
import { authAPI } from '../lib/api';
import { setSession } from '../lib/auth';
import { t } from '../lib/i18n';
import { handleAccessRedirect, errorText } from '../lib/authErrors';

// Landing for the My Account quick link: /sso?token=<one-time sso_tokens token>.
// Exchanges the token at /api/auth/sso-login and enters the app.
export default function SsoLanding() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return; // tokens are one-time — never exchange twice (StrictMode)
    ran.current = true;
    const token = params.get('token') || '';
    if (!token) {
      setError(t('Missing SSO token'));
      return;
    }
    authAPI
      .ssoLogin(token)
      .then(({ data }) => {
        setSession(data.token, { name: data.name, role: data.role, mid: data.mid || '', lr: data.lr || null });
        navigate('/', { replace: true });
      })
      .catch((err) => {
        // Entrada desde Mi Cuenta: un acceso denegado (sin permiso o mentoría
        // sin aprobar) devuelve al miembro a Mi Cuenta, no a una página muerta.
        if (handleAccessRedirect(err)) return;
        setError(errorText(err, t('SSO sign-in failed')));
      });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">
        <Brand size="lg" className="justify-center" />
        {error ? (
          <div className="mt-6 rounded-lg border border-lms-border bg-lms-surface p-6">
            <p role="alert" className="text-sm" style={{ color: 'var(--lms-danger)' }}>{error}</p>
            <Link to="/login" className="mt-4 inline-block text-sm text-lms-accent underline">
              {t('Go to sign in')}
            </Link>
          </div>
        ) : (
          <p className="mt-4 text-sm text-lms-muted">{t('Signing you in…')}</p>
        )}
      </div>
    </div>
  );
}
